import React from 'react';

import { useAppDispatch, useAppSelector } from '@/store';
import { selectStudioPeriod, setStudioPeriod } from '@/store/slices/studioPeriod';

import type { HomePeriod } from '../../mock-data/types';

/**
 * The range a page with a Home / Stats picker shows: the one the owner last picked on any page (see the `studioPeriod`
 * slice), else the page's own `fallback` until they pick one. Picking here sets it for every page.
 */
export const useStudioPeriod = (fallback: HomePeriod): [HomePeriod, (period: HomePeriod) => void] => {
  const dispatch = useAppDispatch();
  const picked = useAppSelector(selectStudioPeriod);
  const pick = React.useCallback((period: HomePeriod): void => void dispatch(setStudioPeriod(period)), [dispatch]);
  return [picked ?? fallback, pick];
};

export default useStudioPeriod;
